module.exports = __webpack_public_path__ + "images/emoji/rose.9e3e07987c8bc2e0f515.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rose.png
// module id = 6PvH
// module chunks = 13